import { useMemo } from 'react';

import { Callable, Optional } from '@vimeo/core/types/generic';
import { CallablePlaceholder } from '@vimeo/live-core/types/general';

import { sharedTranslations as translations } from '../../../../translations/shared';

export interface IUseNoticeParams {
  blockedUser: Optional<string>;
  showNewMessageNotice: boolean;
  showBlockedUserNotice: boolean;
  scrollChatHistoryToBottom: Callable;
  handleCloseBlockUserNotice: Callable;
}

export interface INoticeProps {
  content: string;
  showing: boolean;
  onClickAction: Callable;
}

export function useNoticeProps({
  showNewMessageNotice,
  scrollChatHistoryToBottom,
  showBlockedUserNotice,
  blockedUser,
  handleCloseBlockUserNotice,
}: IUseNoticeParams): INoticeProps {
  return useMemo(() => {
    if (showNewMessageNotice)
      return {
        showing: showNewMessageNotice,
        content: translations.newMessagesReceived,
        onClickAction: scrollChatHistoryToBottom,
      };

    if (showBlockedUserNotice)
      return {
        showing: showBlockedUserNotice,
        content: translations.userWasBlocked(blockedUser || translations.noName),
        onClickAction: handleCloseBlockUserNotice,
      };

    return {
      showing: false,
      content: '',
      onClickAction: CallablePlaceholder,
    };
  }, [
    showNewMessageNotice,
    scrollChatHistoryToBottom,
    showBlockedUserNotice,
    blockedUser,
    handleCloseBlockUserNotice,
  ]);
}
